"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _1 = require(".");

var await_lock_1 = __importDefault(require("await-lock"));

var ethereumjs_tx_1 = __importDefault(require("ethereumjs-tx"));

var U2fTransport = require("@ledgerhq/hw-transport-u2f").default;

var LedgerEth = require("@ledgerhq/hw-app-eth").default;

var Ledger = function (_super) {
  __extends(Ledger, _super);

  function Ledger() {
    var _this = _super.call(this) || this;

    _this.awaitLock = new await_lock_1.default();
    _this.connected = false;
    var selectedBasePath = window.localStorage.getItem("Ledger:selectedBasePath") || Ledger.PATH_TYPE.LEGACY;
    var selectedIndex = Number(window.localStorage.getItem("Ledger:selectedIndex")) || 0;
    Ledger.setPath(selectedBasePath, selectedIndex);
    return _this;
  }

  Ledger.prototype.initTransport = function () {
    return __awaiter(this, void 0, void 0, function () {
      var transport;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, U2fTransport.create()];

          case 1:
            transport = _a.sent();
            this.eth = new LedgerEth(transport);
            return [2];
        }
      });
    });
  };

  Ledger.getPathType = function (basePath) {
    return Object.values(Ledger.PATH_TYPE).indexOf(basePath) > -1 ? basePath : Ledger.CUSTOMIZAION_PATH;
  };

  Ledger.setPath = function (basePath, index) {
    Ledger.currentBasePath = basePath;
    window.localStorage.setItem("Ledger:selectedBasePath", basePath);
    Ledger.currentIndex = index;
    window.localStorage.setItem("Ledger:selectedIndex", String(index));
  };

  Ledger.prototype.currentPath = function () {
    return Ledger.currentBasePath + "/" + Ledger.currentIndex.toString();
  };

  Ledger.prototype.type = function () {
    return Ledger.TYPE;
  };

  Ledger.prototype.id = function () {
    return Ledger.TYPE;
  };

  Ledger.prototype.signMessage = function (message) {
    return this.signPersonalMessage(message);
  };

  Ledger.prototype.signPersonalMessage = function (message) {
    return __awaiter(this, void 0, void 0, function () {
      var result, v, vHex;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0,, 3, 4]);

            return [4, this.awaitLock.acquireAsync()];

          case 1:
            _a.sent();

            if (message.slice(0, 2) === "0x") {
              message = message.slice(2);
            } else {
              message = Buffer.from(message).toString("hex");
            }

            return [4, this.eth.signPersonalMessage(this.currentPath(), message)];

          case 2:
            result = _a.sent();
            v = parseInt(result.v, 10) - 27;
            vHex = v.toString(16);

            if (vHex.length < 2) {
              vHex = "0" + v;
            }

            return [2, "0x" + result.r + result.s + vHex];

          case 3:
            this.awaitLock.release();
            return [7];

          case 4:
            return [2];
        }
      });
    });
  };

  Ledger.prototype.signTransaction = function (txParams) {
    return __awaiter(this, void 0, void 0, function () {
      var networkID, tx, result, signedChainId, validChainId;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0,, 4, 5]);

            return [4, this.awaitLock.acquireAsync()];

          case 1:
            _a.sent();

            return [4, this.loadNetworkId()];

          case 2:
            networkID = _a.sent();
            tx = new ethereumjs_tx_1.default(txParams);
            tx.raw[6] = Buffer.from([networkID]);
            tx.raw[7] = Buffer.from([]);
            tx.raw[8] = Buffer.from([]);
            return [4, this.eth.signTransaction(this.currentPath(), tx.serialize().toString("hex"))];

          case 3:
            result = _a.sent();
            tx.v = Buffer.from(result.v, "hex");
            tx.r = Buffer.from(result.r, "hex");
            tx.s = Buffer.from(result.s, "hex");
            signedChainId = Math.floor((tx.v[0] - 35) / 2);
            validChainId = networkID & 0xff;

            if (signedChainId !== validChainId) {
              throw new Error("Invalid networkId signature returned. Expected: " + networkID + ", Got: " + signedChainId);
            }

            return [2, "0x" + tx.serialize().toString("hex")];

          case 4:
            this.awaitLock.release();
            return [7];

          case 5:
            return [2];
        }
      });
    });
  };

  Ledger.prototype.sendTransaction = function (txParams) {
    return __awaiter(this, void 0, void 0, function () {
      var currentAddress, nonce, rawData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!txParams.nonce) return [3, 3];
            return [4, this.getAddresses()];

          case 1:
            currentAddress = _a.sent();
            return [4, _1.getTransactionCount(currentAddress[0], "pending")];

          case 2:
            nonce = _a.sent();
            txParams.nonce = nonce;
            _a.label = 3;

          case 3:
            return [4, this.signTransaction(txParams)];

          case 4:
            rawData = _a.sent();
            return [2, _1.sendRawTransaction(rawData)];
        }
      });
    });
  };

  Ledger.prototype.getAddressesWithPath = function (basePath, from, count) {
    return __awaiter(this, void 0, void 0, function () {
      var addresses, i, path, address, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 6,, 7]);

            return [4, this.awaitLock.acquireAsync()];

          case 1:
            _a.sent();

            addresses = {};
            i = from;
            _a.label = 2;

          case 2:
            if (!(i < from + count)) return [3, 5];
            path = basePath + "/" + i.toString();
            return [4, this.eth.getAddress(path, false, false)];

          case 3:
            address = _a.sent();
            addresses[path] = address.address.toLowerCase();
            _a.label = 4;

          case 4:
            i++;
            return [3, 2];

          case 5:
            this.connected = true;
            this.awaitLock.release();
            return [2, addresses];

          case 6:
            e_1 = _a.sent();
            this.connected = false;
            throw e_1;

          case 7:
            return [2];
        }
      });
    });
  };

  Ledger.prototype.getAddresses = function () {
    return __awaiter(this, void 0, void 0, function () {
      var address;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.getAddressesWithPath(Ledger.currentBasePath, Ledger.currentIndex, 1)];

          case 1:
            address = _a.sent();
            return [2, Object.values(address)];
        }
      });
    });
  };

  Ledger.prototype.isSupported = function () {
    return !this.connected;
  };

  Ledger.prototype.isLocked = function () {
    return !this.connected;
  };

  Ledger.prototype.loadNetworkId = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2, _1.getNetworkID()];
      });
    });
  };

  Ledger.prototype.sendCustomRequest = function (method, params) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2, null];
      });
    });
  };

  Ledger.prototype.name = function () {
    return "Ledger";
  };

  Ledger.LABEL = "Ledger";
  Ledger.TYPE = "LEDGER";
  Ledger.PATH_TYPE = {
    LEDGER_LIVE: "m/44'/60'/0'/0",
    LEGACY: "m/44'/60'/0'"
  };
  Ledger.CUSTOMIZAION_PATH = "Customization";
  Ledger.PREFIX_ETHEREUM_PATH = "m/44'/60'/";
  return Ledger;
}(_1.BaseWallet);

exports.default = Ledger;